import newAccount from './newAccount.js';

/**
 *
 * User
 *
 * @namespace User
 */
newAccount.User = {
    instance: 'newAccount.User',

    // ---------------------------------------------
    //
    //        Public Methods
    //
    // ---------------------------------------------

    /**
     * Constructor
     * @memberof User
     * @example
     * User.init(userData)
     * @param userData
     */
    init: function(userData){
        if (userData && userData.user) {
            userData = userData.user;
        }

        if (userData && userData !== null){
            this.id = userData.id;
            this.executiveId = userData.executiveId;
            this.highestRank = userData.highestRank;
            this.displayName = userData.displayName;
            this.firstName = userData.firstName;
            this.lastName = userData.lastName;
            this.localName = userData.localName;
            this.sponsorId = userData.sponsorId;
            this.accountType = userData.accountType;
            this.priceType = userData.priceType;
            this.countryCd = userData.countryCd;
            this.eid = userData.eid;
            this.isGuest = userData.isGuest;
            this.authenticationType = userData.authenticationType;
            this.email = userData.email;
            this.simple = userData.simple;
            this.isCircleGroupLeader = userData.isCircleGroupLeader;
            this.qualifyingCode = userData.qualifyingCode;
            this.loginTime = userData.loginTime;
            this.pingTimestamp = userData.pingTimestamp;
            this.volumes = userData.volumes;
            this.isVolumesLoaded = userData.isVolumesLoaded;
            this.availablePoints = userData.availablePoints;
            this.federatedId = userData.federatedId;
            this.personId = userData.personId;
            this.noFalloutMsg = userData.noFalloutMsg;
            this.phone = {...userData.phone};
            this.photoURL = userData.photoURL;
            this.username = userData.username;
            this.emailVerified = userData.emailVerified;
            this.emailNeedsVerify = userData.emailNeedsVerify;
        }
    },


    /**
     * Create JSON object from object data
     * @memberof User
     * @example
     * var userObject = User.toJSON()
     * @returns {object}
     */
    toJSON: function(){
        let user = {};
        user.id = this.id;
        user.executiveId = this.executiveId;
        user.highestRank = this.highestRank;
        user.displayName = this.displayName;
        user.firstName = this.firstName;
        user.lastName = this.lastName;
        user.localName = this.localName;
        user.sponsorId = this.sponsorId;
        user.accountType = this.accountType;
        user.priceType = this.priceType;
        user.countryCd = this.countryCd;
        user.eid = this.eid;
        user.isGuest = this.isGuest;
        user.authenticationType = this.authenticationType;
        user.email = this.email;
        user.simple = this.simple;
        user.isCircleGroupLeader = this.isCircleGroupLeader;
        user.pingTimestamp = this.pingTimestamp;
        user.qualifyingCode = this.qualifyingCode;
        user.loginTime = this.loginTime;
        user.pingTimestamp = this.pingTimestamp;
        user.volumes = this.volumes;
        user.isVolumesLoaded = this.isVolumesLoaded;
        user.availablePoints = this.availablePoints;
        user.federatedId = this.federatedId;
        user.personId = this.personId;
        user.noFalloutMsg = this.noFalloutMsg;
        user.phone = {...this.phone};
        user.photoURL = this.photoURL;
        user.username = this.username;
        user.emailVerified = this.emailVerified;
        user.emailNeedsVerify = this.emailNeedsVerify;

        return user;
    },

    // ---------------------------------------------
    //
    //    Check to see if object is empty
    //
    // ---------------------------------------------

    /**
     * @memberof User
     * @example
     * User.isEmpty()
     * @returns {boolean}
     */
    isEmpty: function(){
        return this.isFieldEmpty(this.id) &&
            this.isFieldEmpty(this.executiveId) &&
            this.isFieldEmpty(this.highestRank) &&
            this.isFieldEmpty(this.displayName) &&
            this.isFieldEmpty(this.firstName) &&
            this.isFieldEmpty(this.lastName) &&
            this.isFieldEmpty(this.localName) &&
            this.isFieldEmpty(this.sponsorId) &&
            this.isFieldEmpty(this.accountType) &&
            this.isFieldEmpty(this.priceType) &&
            this.isFieldEmpty(this.countryCd) &&
            this.isFieldEmpty(this.eid) &&
            this.isFieldEmpty(this.isGuest) &&
            this.isFieldEmpty(this.authenticationType) &&
            this.isFieldEmpty(this.email) &&
            this.isFieldEmpty(this.simple) &&
            this.isFieldEmpty(this.isCircleGroupLeader) &&
            this.isFieldEmpty(this.qualifyingCode) &&
            this.isFieldEmpty(this.loginTime) &&
            this.isFieldEmpty(this.pingTimestamp) &&
            this.isFieldEmpty(this.volumes) &&
            this.isFieldEmpty(this.federatedId) &&
            this.isFieldEmpty(this.personId) &&
            this.isFieldEmpty(this.isVolumesLoaded) &&
            this.isFieldEmpty(this.username) &&
            this.isFieldEmpty(this.emailVerified) &&
            this.isFieldEmpty(this.emailNeedsVerify) &&
            this.isFieldEmpty(this.availablePoints);
    },

    /**
     * @memberof User
     * @example
     * User.isDistributor()
     * @returns {boolean}
     */
    isDistributor: function() {
        return this.accountType == "10";
    },

    /**
     * @memberof User
     * @example
     * User.isCustomer()
     * @returns {boolean}
     */
    isCustomer: function() {
        return this.accountType == "20";
    },

    /**
     * @memberof User
     * @example
     * var browserName = User.isPreferredCustomer()
     * @returns {boolean}
     */
    isPreferredCustomer: function() {
        return this.accountType == "30";
    },

    /**
     * @memberof User
     * @example
     * var browserName = User.isFieldEmpty()
     * @returns {boolean}
     */
    isFieldEmpty: function(fieldValue){
        return fieldValue === null || fieldValue === undefined || fieldValue.length === 0;
    },

    /**
     * @memberOf User
     * @example
     * user.getDisplayName()
     * @returns {string} displayName
     */
    getDisplayName: function() {
        let displayName = "";
        if (this.displayName) {
            displayName = this.displayName;
        } else if (this.localName) {
            displayName = this.localName;
        } else {
            if (this.firstName) {
                displayName = this.firstName + " ";
            }
            if (this.lastName) {
                displayName += this.lastName;
            }
        }
        return displayName;
    }
};

export default newAccount.User;
